import React, { useContext } from 'react';
import classNames from 'classnames';
import { useCmsUSPMenuQuery } from '@/api/cms/cms';
import { Link } from '@/components/shared/Link/Link';
import { SegmentationContext } from '@/contexts/SegmentationContext';
import { useGetSettings } from '@/generated/settings';
import { CustomerSelector } from './CustomerSelector';
import { LanguageDropdown } from './LanguageDropdown';
import styles from './TopBar.module.scss';

interface TopBarProps {
	hideCustomerSelector?: boolean;
}

export const TopBar: React.FunctionComponent<TopBarProps> = ({ hideCustomerSelector }) => {
	const { segmentationId } = useContext(SegmentationContext);
	const { data: settings } = useGetSettings(segmentationId);
	const isSalesPortal = settings?.data.isSalesPortal ?? true;

	const { data: cmsUSPMenu } = useCmsUSPMenuQuery(
		settings?.data,
		settings?.data.cmsSettings.uspMenu || '',
		isSalesPortal,
	);

	const segmentations = settings?.data.segmentations;

	const showLanguageDropdown = segmentations && segmentations.length > 0;

	return (
		<div className={styles.topBar}>
			<div className={classNames(styles.topBarInner, 'u-container-lg')}>
				{cmsUSPMenu && cmsUSPMenu.length > 0 && (
					<ul className={styles.uspWrapper}>
						{cmsUSPMenu.map((usp) => (
							<li key={usp.id} className={styles.uspMenuItem}>
								<Link
									size={'sm'}
									to={usp.internalLink}
									linkUrl={usp.externalLink}
									title={usp.title || ''}
									textLink
								>
									<span>{usp.title}</span>
								</Link>
							</li>
						))}
					</ul>
				)}
				{!hideCustomerSelector ? <CustomerSelector /> : null}
				{showLanguageDropdown ? <LanguageDropdown /> : null}
			</div>
		</div>
	);
};
